<script>
	//@ts-nocheck
	import { page } from '$app/stores';

	const MEASUREMENT_ID = import.meta.env.VITE_MEASUREMENT_ID || 'G-V9KH7WR2LE';

	$: {
		if (typeof gtag !== 'undefined') {
			gtag('config', MEASUREMENT_ID, {
				page_title: document.title,
				page_path: $page.url.pathname
			});
		}
	}
</script>

<svelte:head>
	<script async src={`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`}></script>
	<script>
		window.dataLayer = window.dataLayer || [];

		function gtag() {
			dataLayer.push(arguments);
		}

		// Initialize Google Analytics with 'js' and the current date
		gtag('js', new Date());
		// Configure Google Analytics with 'config' and the 'MEASUREMENT_ID'
		gtag('config', 'G-V9KH7WR2LE');
	</script>
</svelte:head>
